var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: { width: "100%" },
                  attrs: { "label-width": "80px", "label-position": "top" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: {
                        label: this.$t("SeaExport.ShippingCompanyContractNo"),
                        required: true
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "contractNumber",
                          placeholder: _vm.$t(
                            "SeaExport.PleaseEnterTheShippingCompanyContractNumber"
                          )
                        },
                        on: { input: _vm.handleContractNumberInput },
                        model: {
                          value: _vm.form.contractNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contractNumber", $$v)
                          },
                          expression: "form.contractNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: {
                        label: _vm.$t("SeaExport.ContractRateProperty"),
                        required: true
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "priceNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            clearable: false,
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.priceNature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "priceNature", $$v)
                            },
                            expression: "form.priceNature"
                          }
                        },
                        _vm._l(_vm.bookingTerms, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "100%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: { label: this.$t("Message.ApplicableRoute") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          multiple: "",
                          "default-multiple-value": _vm.form.applicableRoutes,
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          placeholder: _vm.$t("SeaExport.PleaseSelectAirLine")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.applicableRoutes = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: { label: _vm.$t("SeaExport.ShippingCompany") }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "shippingCompany",
                          "method-params": {
                            companyLob: "seaExport",
                            seaCmp: true,
                            active: true
                          },
                          "default-value": _vm.form.shippingCompany || "",
                          placeholder: _vm.$t(
                            "SeaExport.PleaseSelectShippingCompany"
                          )
                        },
                        on: {
                          change: function(p) {
                            _vm.form.shippingCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", {
                    staticStyle: {
                      width: "50%",
                      "padding-right": "10px",
                      "box-sizing": "border-box"
                    }
                  }),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: { label: this.$t("SeaExport.IsNac") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "weatherNac",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini",
                            clearable: true
                          },
                          on: { change: _vm.handleNacChange },
                          model: {
                            value: _vm.form.weatherNac,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "weatherNac", $$v)
                            },
                            expression: "form.weatherNac"
                          }
                        },
                        _vm._l(
                          _vm.SystemConstants.YESORNO_COMMON_STATES,
                          function(item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: {
                                label:
                                  _vm.$store.getters.language === "zh"
                                    ? item.chineseName
                                    : item.englishName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.showNacFields
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "compact-form-item",
                          staticStyle: {
                            width: "100%",
                            "padding-right": "10px",
                            "box-sizing": "border-box"
                          },
                          attrs: { label: "NAC", required: true }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "margin-bottom": "10px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "100%",
                                  "max-width": "800px"
                                },
                                attrs: {
                                  no: "defaultParam",
                                  placeholder:
                                    _vm.$t("SeaExport.PleaseEnterNAC") + 1
                                },
                                on: {
                                  input: function(val) {
                                    return _vm.$emit(
                                      "update:form",
                                      Object.assign({}, _vm.form, {
                                        defaultParam: val
                                      })
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.defaultParam,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "defaultParam", $$v)
                                  },
                                  expression: "form.defaultParam"
                                }
                              }),
                              _c("el-button", {
                                staticStyle: {
                                  color: "#42b983",
                                  "margin-left": "10px"
                                },
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-circle-plus"
                                },
                                on: { click: _vm.addNacForm }
                              })
                            ],
                            1
                          ),
                          _vm._l(_vm.form.nacList, function(nac, index) {
                            return _c(
                              "div",
                              {
                                key: nac.uuid,
                                staticStyle: { "margin-bottom": "10px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "data-uuid": nac.uuid,
                                        no: "param",
                                        placeholder:
                                          _vm.$t("SeaExport.PleaseEnterNAC") +
                                          Number(index + 2)
                                      },
                                      model: {
                                        value: nac.param,
                                        callback: function($$v) {
                                          _vm.$set(nac, "param", $$v)
                                        },
                                        expression: "nac.param"
                                      }
                                    }),
                                    _c("el-button", {
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "margin-left": "10px"
                                      },
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-remove"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteNacForm(nac, index)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: {
                        label: this.$t("SeaExport.ApplicableProductName")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "applicableProducts",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            clearable: false,
                            size: "mini"
                          },
                          on: { change: _vm.handleProductNameChange },
                          model: {
                            value: _vm.form.applicableProducts,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "applicableProducts", $$v)
                            },
                            expression: "form.applicableProducts"
                          }
                        },
                        _vm._l(_vm.productNames, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.showProductName
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "compact-form-item",
                          staticStyle: {
                            width: "50%",
                            "padding-right": "10px",
                            "box-sizing": "border-box"
                          },
                          attrs: {
                            label: this.$t("SeaExport.CommodityName"),
                            required: true
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "productName",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseEnterTheCommodityNameOrHSCode"
                              )
                            },
                            model: {
                              value: _vm.form.productName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "productName", $$v)
                              },
                              expression: "form.productName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: { label: "MQC" }
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            no: "mqc",
                            length: "100",
                            type: "number",
                            placeholder: _vm.$t("SeaExport.PleaseInputNumber"),
                            oninput: "value=value.replace(/[^0-9]/g,'')"
                          },
                          model: {
                            value: _vm.form.mqc,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mqc", $$v)
                            },
                            expression: "form.mqc"
                          }
                        },
                        [
                          _c("template", { slot: "append" }, [
                            _c("span", [_vm._v("TEU")])
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: { label: this.$t("SeaExport.CargoInsurance") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "cabinGuarantee",
                            placeholder: _vm.$t("SeaExport.PleaseSelect")
                          },
                          on: { change: _vm.handleCabinGuaranteeChange },
                          model: {
                            value: _vm.form.cabinGuarantee,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cabinGuarantee", $$v)
                            },
                            expression: "form.cabinGuarantee"
                          }
                        },
                        _vm._l(_vm.SystemConstants.HAVENONE_STATES, function(
                          item
                        ) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.showCabinGuarantee
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "compact-form-item",
                          staticStyle: {
                            width: "50%",
                            "padding-right": "10px",
                            "box-sizing": "border-box"
                          },
                          attrs: {
                            label: this.$t("SeaExport.CargoInsuranceQuantity"),
                            required: true
                          }
                        },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "cabinQuantity",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseInputNumber"
                              ),
                              precision: 2
                            },
                            model: {
                              value: _vm.form.cabinQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cabinQuantity", $$v)
                              },
                              expression: "form.cabinQuantity"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showCabinGuarantee
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "compact-form-item",
                          staticStyle: {
                            width: "50%",
                            "padding-right": "10px",
                            "box-sizing": "border-box"
                          },
                          attrs: {
                            label: this.$t("SeaExport.CargoInsuranceUnit"),
                            required: true
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "cabinUnit",
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                clearable: false,
                                size: "mini"
                              },
                              model: {
                                value: _vm.form.cabinUnit,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cabinUnit", $$v)
                                },
                                expression: "form.cabinUnit"
                              }
                            },
                            _vm._l(_vm.cabinUnitNames, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: {
                        label: this.$t("SeaExport.ValidityStartDate"),
                        required: true
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "departure-date-picker",
                        staticStyle: { flex: "1", "margin-right": "5px" },
                        attrs: {
                          no: "validityStart",
                          value: _vm.form.validityStart,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.validityStartChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "compact-form-item",
                      staticStyle: {
                        width: "50%",
                        "padding-right": "10px",
                        "box-sizing": "border-box"
                      },
                      attrs: {
                        label: this.$t("SeaExport.ValidityEndDate"),
                        required: true
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "departure-date-picker",
                        staticStyle: { flex: "1", "margin-right": "5px" },
                        attrs: {
                          no: "validityEnd",
                          value: _vm.form.validityEnd,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.validityEndChange }
                      })
                    ],
                    1
                  ),
                  this.isEdit
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "compact-form-item",
                          staticStyle: {
                            width: "50%",
                            "padding-right": "10px",
                            "box-sizing": "border-box"
                          },
                          attrs: { label: this.$t("Message.IsEnable") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: true,
                                no: "weatherEnabled",
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                size: "mini",
                                clearable: true
                              },
                              model: {
                                value: _vm.form.weatherEnabled,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "weatherEnabled", $$v)
                                },
                                expression: "form.weatherEnabled"
                              }
                            },
                            _vm._l(
                              _vm.SystemConstants.YESORNO_COMMON_STATES,
                              function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }